import gql from 'graphql-tag';

import { CUSTOMER_PERSONA_FRAGMENT } from 'src/graphql/customerPersona';
import { FRAGMENT_CONTENT_MARKUP } from 'src/graphql/schema';

export const FRAGMENT_LONG_FORM_VARIABLES = gql`
  fragment LongFormVariables on LongFormVariables {
    info
    title
  }
`;

export const FRAGMENT_CONTEXT_ITEM = gql`
  fragment ContextItem on ContextItem {
    name
    title
    text
    allInstructionsData
    description
  }
`;

export const FRAGMENT_LONG_FORM_BUILDER_PROJECT = gql`
  fragment LongFormBuilderProject on LongFormBuilderProject {
    id
    generationTool
    language
    customerMultiPromptTemplateId
    contentImproverData
    associatedResources {
      id
      text
      type
    }
    brandVoiceIdsForBrandTerms
    customerPersona {
      ...CustomerPersona
    }
    wordCount
    tovInput
    blocks {
      blockId
      allInstructionsData
      structureInstructionsData
      generationTool
      name
      order
      tovInput
      language
    }
    promptFields
    contextQuestions {
      ...ContextItem
    }
    descriptionAllInstructionsData
    variables {
      ...LongFormVariables
    }
  }
  ${FRAGMENT_LONG_FORM_VARIABLES}
  ${FRAGMENT_CONTEXT_ITEM}
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

export const FRAGMENT_PROJECT_LONG_FORM_BUILDER_OUTLINE_SECTION = gql`
  fragment LongFormBuilderOutlineSection on LongFormBuilderOutlineSection {
    id
    projectId
    name
    headline
    status
    content
    contentMarkup {
      ...ContentMarkup
    }
    order
    originalSectionId
    manualKeywords
    instructions
    generationLength
    textStatus
    allInstructionsData
    assetType
    score
    engagementScoreSupportSize
  }
  ${FRAGMENT_CONTENT_MARKUP}
`;

export const FRAGMENT_LONG_FORM_BUILDER_DRAFT = gql`
  fragment LongFormBuilderDraft on LongFormBuilderDraft {
    id
    projectId
    draftId
    status
    chainId
    name
    generationInfo
  }
`;

export const BLOG_POST_BUILDER_DRAFT = gql`
  fragment BlogPostBuilderDraft on BlogPostBuilderDraft {
    id
    projectId
    draftId
    status
    name
    generationInfo
    language
  }
`;
